import {AndroidOutlined} from '@ant-design/icons'
import Menu from '../components/Menu.jsx'
import useMenuItemAiAgentDefault from './useMenuItemAiAgentDefault.jsx'
import useMenuItemAiChatDefault from './useMenuItemAiChatDefault.jsx'
import useMenuItemAiGenerateAis from './useMenuItemAiGenerateAis.jsx'
import useMenuItemAiGenerateAisPattern from './useMenuItemAiGenerateAisPattern.jsx'

export default function MainMenu(props) {
    const items = [
        {
            title: <AndroidOutlined />,

            children: [
                useMenuItemAiChatDefault(),
                //useMenuItemAiAgentDefault(),
                useMenuItemAiGenerateAis(),
                useMenuItemAiGenerateAisPattern(),
            ],
        }
    ]

    return (
        <Menu
            items={items}
            {...props}
        />
    )
}
